/**
 * Module dependencies.
 */

import { Context, createContext, useContext } from 'react';

/**
 * `Result` type.
 */

type Result = {
  sort: string;
  submittedSort: string;
};

/**
 * Export `SortContext` context.
 */

export const SortContext: Context<{
  isSortSelected?: (value: string) => boolean;
  omitUrl?: boolean;
  onClear?: () => Result;
  onSet?: (value: string) => Result;
  onSubmit?: () => Result;
  reset?: () => Result;
  sort?: string;
  submittedSort?: string;
}> = createContext({});

/**
 * Export `useSort` hook.
 */

export const useSort = () => useContext(SortContext);
